import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { Staffs } from '../Staffs';
import { Roles } from '../roles';
import { ReferenceNumbersPage } from './ReferenceNumbers';
import { Teams } from '../Teams';

export function AccessSettingsPage(): React.ReactElement {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const requestedKey = searchParams.get('tab') || 'staff';

  const items = [
    {
      key: 'staff',
      label: 'Staff',
      children: <Staffs />,
    },
    {
      key: 'teams',
      label: 'Teams',
      children: <Teams />,
    },
    {
      key: 'roles',
      label: 'Roles',
      children: <Roles />,
    },
    {
      key: 'reference',
      label: 'Reference',
      children: <ReferenceNumbersPage />,
    },
  ];
  const availableKeys = new Set(items.map((item) => item.key));
  const activeKey = availableKeys.has(requestedKey) ? requestedKey : 'staff';

  return (
    <Tabs
      items={items}
      activeKey={activeKey}
      destroyInactiveTabPane={false}
      onChange={(key) => {
        const nextParams = new URLSearchParams(location.search);
        nextParams.set('tab', key);
        navigate({ pathname: location.pathname, search: nextParams.toString() }, { replace: true });
      }}
    />
  );
}
